<script>
    import {createEventDispatcher, onMount} from "svelte";
    import {GlobalStore} from "../../stores/stores";
    import ErrorUi from "./ErrorUi.svelte";
    import {get} from "svelte/store";
    import Loading from "./Loading.svelte";

    const dispatch = createEventDispatcher();
    let data;
    let loading = true;
    let error = false;
    let projectId;
    const url = window.location.href ?? "http://localhost:3001/";

    onMount(async () => {
        const formData = get(GlobalStore);
        data = JSON.stringify(formData, null, 2);

        console.log('querying', url)

        fetch(`${url}api/project`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(formData)
        })
            .then((res) => res.json())
            .then((response) => {
                if (response.id) {
                    console.log("projectId", response.id);
                    projectId = response.id;
                    loading = false;
                } else {
                    loading = false;
                    error = true;
                }
            })
            .catch(() => {
                loading = false;
                error = true;
            });

    });

    function getContractPath() {
        return `${url}api/contract/${projectId}`;
    }

    function restartForm() {
        dispatch("restart");
    }

</script>

<div>
    {#if loading}
        <Loading/>
    {/if}

    {#if !loading}

        {#if error }
            <ErrorUi on:restart={restartForm}/>
        {/if}

        {#if !error }
            <div>

                <div class="text-center">

                    <p>Les informations ont été enregistrées avec succès.</p>
                    <p>Les documents précontractuels vous ont été envoyés par email.</p>

                </div>
                <hr class="opacity-25" style="margin-top: 2rem"/>

                <div style="margin: 2rem auto 0; width: max-content">

                    <h5 class="mb-3">Dernières étapes&nbsp;:</h5>
                    <ol style="padding-left: 10px">
                        <li class="mb-2">
                            <a href={getContractPath()} target="_blank">Télécharger le contrat</a>
                        </li>
                        <li class="mb-2">
                            Signer le contrat
                        </li>
                        <li class="mb-2">
                            Envoyer le contrat signé à <a href="mailto:lba@lbaconseil.fr">lba@lbaconseil.fr</a>
                        </li>
                        <li class="">
                            Vous êtes assuré ! Vous recevrez prochainement par email les documents contractuels.
                        </li>
                    </ol>
                </div>
            </div>
        {/if}

    {/if}


</div>